export default {
    acl: {
        are_you_sure: 'Are you sure?',
        delete_role_and_permissions: 'Delete role and permissions',
        edit: 'Edit an access control level',
        id: 'ID',
        menu: {
            create: 'New',
            index: 'ACL',
            list: 'ACL'
        },
        permissions: 'Permissions',
        role: 'Role',
        select_all_permissions: 'Select all',
        select_all_permissions_in_this_column: 'Select all',
        setting: 'Edit | Delete',
        tag: 'Tag'
    },
    no: 'No',
    yes: 'Yes'
}



